<template>
  <b-container tag="article" data-aos="fade-up">
    <b-img-lazy
      class="w-100"
      alt="Picture of a group of people eating Christmas dinner"
      src="../../../assets/news/Xmas1.jpg"
    />
    <h1 class="mt-5 mb-2 text-primary">Not just a Car Scheme</h1>
    <h2 class="mb-2 text-info">Jan 8, 2018</h2>
    <p>
      Drivers and passengers joined partners and friends to enjoy an excellent
      Christmas lunch at the White Hart at North Scarle in early December.
      Passengers were all transported to and from the event by drivers and we
      all enjoyed a complimentary drink on arrival at the pub to get into a
      festive mood. The delicious three course meal went down well and the
      atmosphere was convivial with everyone enjoying the chance to get to know
      each other a little better. Being a driver or passenger has had unexpected
      benefits for all of us. It has helped develop friendships as well as the
      chance to get to know neighbours from our own and other villages. If you
      would be interested in becoming a driver or registering as a passenger you
      will receive a warm welcome so why not make 2018 the year you join us!
    </p>
  </b-container>
</template>

<script>
export default {
  name: "NotJustACarScheme",
};
</script>
